const generateHours = (interval: number) => {
  const times = []

  let startDate = 60 * 0
  const endDate = 60 * 24

  for (let i = 0; startDate < 24 * 60; i++) {
    if (startDate > endDate) break

    let hh = Math.floor(startDate / 60)
    let mm = startDate % 60

    const ampm = hh >= 12 ? 'PM' : 'AM'
    const labelHrs = hh > 12 ? hh - 12 : hh

    times.push({
      value: {
        hour: hh,
        minute: mm
      },
      label: `${labelHrs}:${('0' + mm).slice(-2)} ${ampm}`
    })

    startDate = startDate + interval
  }

  return times
}

export { generateHours }
